module.exports = __webpack_public_path__ + "static/media/logo_munvo_picto-h_inverse.a94abb27.svg";